"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSunOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 8a8 8 0 108 8 8 8 0 00-8-8zm0 14a6 6 0 116-6 6 6 0 01-6 6zM15 1h2v4h-2zM4.673 6.132l1.402-1.427 2.853 2.804-1.402 1.426zM1 15h4v2H1zM4.699 25.924l2.804-2.853 1.426 1.402-2.803 2.853zM15 27h2v4h-2zM23.075 24.496l1.402-1.426 2.853 2.804-1.402 1.426zM27 15h4v2h-4zM23.072 7.519l2.803-2.854 1.427 1.402-2.804 2.853z" })));
}
exports.default = SvgSunOutline;
//# sourceMappingURL=SunOutline.js.map